
export default {
  props: {
    group: Object,
    module: Object
  },

  data () {
    return {
      isReady: false,
      template: {}
    }
  },

  watch: {
    group: {
      handler (val) {
        if (val) {
          let atLeastOne = false
          for (const entity in val) {
            if (val[entity]) atLeastOne = true
          }
          this.$emit('valid', atLeastOne)
        }
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    _group: {
      set (value) {
        this.$emit('update:group', value)
      },

      get () {
        return this.group
      }
    }
  },

  mounted () {
    if (!this.group) this._group = {}
    this.module.content.forms.forEach(f => {
      this.template[f.content.headline.replace(/ /g, '').toLowerCase()] = {
        module: 'select-button',
        label: f.content.headline,
        icon: f.content.icon
      }
    })
    this.isReady = true
  }
}
